<template>
    <div class="skeleton-container">
        <div class="table">
            <div class="loading card-title shorter-s"></div>
            <div class="loading table-content" v-for="row in rows" :key="'ks-skeleton-table-row-'+row"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ks-skeleton-list",
    props: {
        rows:{
            type: Number,
            default: 10
        }
    },
}
</script>


<style scoped>


@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;500;700&display=swap');

* {
  margin: 16px;
  padding: 16px;
  font-family: 'Red Hat Display', sans-serif;
}


.skeleton-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width:100%
}

.loading {
  position: relative;
  background-color: #f5f5f5;
  overflow: hidden;
}
.loading::after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  animation: 2s loading linear 0.5s infinite;
  background: linear-gradient(90deg, transparent, #ededed, transparent);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transform: translateX(-100%);
  z-index: 1;
}

@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton-container .card-title {
  padding: 8px;
  font-size: 22px;
  font-weight: 700;
}

.skeleton-container .card-title.loading.shorter-s{
  width: 25%;
}

.skeleton-container .table {
  background-color: #fff;
  height: auto;
  width: 100%;
  overflow: hidden;
  margin: 12px;
  border-radius: 3px;
  box-shadow: 9px 17px 45px -29px rgba(0, 0, 0, 0.44);
}

.skeleton-container .table-content {
  padding: 8px;
  font-size: 22px;
  font-weight: 700;
}
.skeleton-container .table-content.loading {
  height: 1rem;
  margin: 1rem;
  border-radius: 3px;
  width: 95%;
}

</style>